export interface TickmillCompanyAllowedReferralsDto {
  tickmillCompany: {
    id: number
    name: string
  }
  allowedCompany: {
    id: number
    name: string
  }
}

export enum TickmillCompanyAllowedReferralsDtoKey {
  id = 'id',
  tickmillCompany = 'tickmillCompany',
  allowedTickmillCompany = 'allowedTickmillCompany',
}
